import { render, staticRenderFns } from "./HeaderFinalizarImportacao.vue?vue&type=template&id=cb731b12&scoped=true&"
import script from "./HeaderFinalizarImportacao.vue?vue&type=script&lang=js&"
export * from "./HeaderFinalizarImportacao.vue?vue&type=script&lang=js&"
import style0 from "./HeaderFinalizarImportacao.vue?vue&type=style&index=0&id=cb731b12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb731b12",
  null
  
)

export default component.exports